module.exports = __webpack_public_path__ + "static/img/1.8eeec20b.png";